import AdminHotelMerge from './admin-hotel-merge-component';

const MODULE_NAME = 'App.admin.hotel-merge';
const module = angular
    .module(MODULE_NAME, [])
    .directive(AdminHotelMerge.DIRECTIVE_NAME, AdminHotelMerge);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-merge/admin-hotel-merge-module.js